<template>
  <div>
    <el-card body-style="padding: 0">
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">我的收益</span>
      </div>
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="用户名" prop="userName">
              <el-input v-model="queryForm.userName" placeholder="请输入用户名"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结算状态" prop="moneyStatus">
              <el-select v-model="queryForm.moneyStatus" clearable placeholder="请选择结算状态">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.value"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="返利类型" prop="returnType">
              <el-select v-model="queryForm.returnType" clearable placeholder="请选择返利类型">
                <el-option
                    v-for="item in returnMoneyTypes"
                    :key="item.value"
                    :label="item.value"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="时间段" prop="timeRange">
              <el-date-picker
                  v-model="queryForm.timeRange"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="6">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询</el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置</el-button>
              <el-button type="primary" size="small" plain
                         @click="importData()" icon="el-icon-refresh">
                导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-row style="line-height: 33px; text-align: center;color: white;background-color: #04befe;">
        <el-col :span="24">
          <span style="margin: 0.5%;">已结算：<span>{{orderInfos.areadyOrder}}</span><!--<span>({{orderInfos.areadyOrder + orderInfos.unReadyOrder}} )单</span>-->单</span>
          <span style="margin: 0.5%;">未结算：<span>{{orderInfos.unReadyOrder}}</span><!--<span>({{orderInfos.areadyOrder + orderInfos.unReadyOrder}})单</span>-->单</span>
          <span style="margin: 0.5%;">商家返利：<span>{{orderInfos.businessOrderMoney}}元</span><span>({{orderInfos.businessOrder}}单)</span></span>
          <!--<span style="margin: 0.5%;">试客返利：<span>{{orderInfos.finishCustomerOrder}}</span><span>({{orderInfos.customerOrder}})单</span></span>-->
        </el-col>
      </el-row>
      <el-table :data="tableData"
                ref="table"
                border default-expand-all stripe
                :max-height="tableHeight"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%;margin-bottom: 20px;"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="userType" label="用户类型" />
        <el-table-column prop="userName" label="用户名" />
        <el-table-column prop="orderNums" label="订单编号" />
        <el-table-column prop="shopName" label="店铺" />
        <el-table-column prop="shopType" label="类型" />
        <el-table-column prop="returnMoneyType" label="返利类型" >
        <template slot-scope="scope">
          <span>{{scope.row.returnMoneyType==2?"货返":"立返"}}</span>
        </template>
        </el-table-column>
        <el-table-column prop="money" label="金额" />
        <el-table-column prop="createTime" label="添加时间" />
        <el-table-column prop="statusStr" label="状态" />
        <el-table-column prop="remarks" label="备注" />
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text"
                       @click="handleEdit(scope.$index, scope.row,'修改字典项')">
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import {querySalemanOrderNum, querySalemanProfit} from "../../api/b2cbusiness/b2c_saleman";
import MinxinScroll from "@/components/MinxinScroll";

export default {
  name: "MyProceeds",
  mixins:[MixinCUD, MinxinScroll],
  data() {
    return {
      tableData:[],
      queryFormRefName:"queryForm",
      returnMoneyTypes:[
        {
          value:"立返"
        },
        {
          value: "货返"
        }
      ],
      options:[
        {
          value:"已结"
        },
        {
          value: "未结"
        }
      ],
      queryForm:{
        userName: '',
        moneyStatus: '',
        returnType: null,
        timeRange: []
      },
      orderInfos:{

      },
      tableHeight: 850,
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    this.getData();
  },
  methods:{
    getData(){
      querySalemanProfit(this.queryForm, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      });

      querySalemanOrderNum().then(res=>{
        if (res.success){
          this.orderInfos = res.data;
        }
      });
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}
</style>
